import { Controller } from "@hotwired/stimulus";
// 5 minutes
const ttl = 5 * 60 * 1000;
// Ignore "returns" faster than this: the status poll navigating a completed
// recheck back to the blocked view stamps a visit just like tabbing away
// does, and without a floor that auto-clicks recheck in an endless loop.
const minimumAway = 15 * 1000;
export default class extends Controller {
  static targets = ["recheckButton"];

  connect() {
    // Always initialize: visibilityChange reads lastVisited, so skipping this
    // on the early return below would leave it undefined and quietly disable
    // departure tracking for the rest of the page's life.
    this.lastVisited = Number(localStorage.getItem("update_checker:last_visited"));

    // A page load caused by the status poller finishing a recheck is not a
    // user returning after a fix, even if they tabbed away while it ran.
    if (this.arrivedViaStatusPoll()) {
      return;
    }

    if (this.lastVisited > 0) {
      this.maybeRecheck();
    }
  }

  arrivedViaStatusPoll() {
    const navigatedAt = Number(sessionStorage.getItem("status_poll:navigated_at"));
    sessionStorage.removeItem("status_poll:navigated_at");

    return navigatedAt > 0 && new Date().getTime() - navigatedAt < minimumAway;
  }

  maybeRecheck() {
    let delta = new Date().getTime() - this.lastVisited
    // if the last check was more than 15 seconds ago and less than 5 minutes ago
    if (delta > minimumAway && delta < ttl) {
      this.recheck();
    }
  }

  recheck() {
    this.lastVisited = 0;
    localStorage.removeItem("update_checker:last_visited");
    this.recheckButtonTarget.click();
  }

  visibilityChange(e) {
    let delta = new Date().getTime() - this.lastVisited;
    // if theres a last visited time and the delta is less stale
    if(this.lastVisited === 0 || delta > ttl) {
      localStorage.setItem("update_checker:last_visited", new Date().getTime());
    }
  }
}
